module.exports = __webpack_public_path__ + "img/sin-archivos.84b8b12d.png";